module.exports = __webpack_public_path__ + "static/media/A2_12.50b80a3b.png";